module dg.objects {

    //function boolDisplayer(): ng.IDirective {
    //    return {
    //        restrict: 'A',
    //        require: ['ngModel'],
    //        templateUrl: '/digmo/src/objects/properties/bool/bool-displayer.html',
    //        //replace: true,
    //        compile: (tElement, tAttrs: ILookupAttributes) => {
    //            var input = angular.element('input', tElement);
    //            input.attr('ng-model', tAttrs.ngModel);
    //            return (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ctrls) => {
    //                var ngModel = ctrls[0];
    //            }
    //        }
    //    };
    //}

    //angular.module('dg.objects')
    //    .directive('boolDisplayer', boolDisplayer);



    export class BoolDisplayerController extends PropertyDisplayerControllerBase<boolean> {

    }


    dg.objects.AngularHelper.registerPropertyDisplayer(TextDisplayerController, 'boolDisplayer', {
        template: '<span ng-bind="$ctrl.value"></span>'
    });
}